import {
  QUERY_BUILDER_CLOSE_BRACKET,
  QueryBuilderOperatorType,
} from '../../../../types';
import { ResolveOptionSubmitActionResultType } from '../../resolveOptionSubmitAction';

export const resolveOperatorOrCloseOptionSubmitAction = (
  value: string
): ResolveOptionSubmitActionResultType => {
  if (value === QUERY_BUILDER_CLOSE_BRACKET) {
    return {
      action: { type: 'closeBracket' },
      shouldReopenDropdownAfterSubmit: false,
    };
  }

  return {
    action: {
      type: 'operator',
      operator: value as QueryBuilderOperatorType,
    },
    shouldReopenDropdownAfterSubmit: false,
  };
};
